export const MODAL_PORTAL_TARGET_SELECTOR = 'body';
